import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserRequest } from '.';
import { API_BASE } from '../api-base.token';
import { UserResponse } from './user-response';

const path = 'users';

@Injectable({
  providedIn: 'root',
})
export class UsersHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  get(email: string) {
    const url = Location.joinWithSlash(this.apiBase, `${path}/${email}`);

    return this.httpClient.get<UserResponse>(url);
  }

  post(request: UserRequest) {
    const url = Location.joinWithSlash(this.apiBase, path);

    return this.httpClient.post(url, request);
  }
}
